import { useEffect } from 'react'
import { confirmAlert } from 'react-confirm-alert'
import { useDispatch, useSelector } from 'react-redux'
import { getArticulo } from '../../../actions/articulo'
import { deleteLinea, postLinea } from '../../../actions/pedidos'
import { getPrecio } from '../../../actions/precios'
import { obtenerValorParametro } from '../../../helpers/funciones'
import i18n from '../../../lang/idiomas'
import Spinner from '../../layout/Spinner'
import Precio from '../Precio'

const LineaCarritoExtrusion = props => {
  const dispatch = useDispatch()

  const pedido = useSelector(state => state.pedidos.pedido)
  const portal = useSelector(state => state.portal.portal)
  const articulo = useSelector(state => state.articulo)
  const cargando_articulo = useSelector(state => state.articulo.isLoading)
  const precio = useSelector(state => state.precios.precio)
  const locale = useSelector(state => state.precios.locale)
  const moneda = useSelector(state => state.precios.moneda)
  const pedido_cargando = useSelector(state => state.pedidos.isLoading)
  const hash = useSelector(state => state.auth.hash)

  const descripcion_sinonimo = obtenerValorParametro(
    portal.parametros_ecom,
    'DESCRIPCION_SINONIMO',
    'ARTA',
  )

  useEffect(() => {
    dispatch(getArticulo(props.linea.articulo, '', 'S'))
    dispatch(
      getPrecio(
        props.linea.articulo,
        props.linea.cantidad_pedida,
        '',
        '',
        props.linea.presentacion_pedido,
      ),
    )
  }, [])

  const convertirLongitud = articulo => {
    let medida = articulo.substr(articulo.indexOf('X'), 5)

    if (medida.indexOf('X') !== -1) {
      medida = medida.substr(medida.indexOf('X') + 1, 4)
    }

    if (medida.substr(0, 1) > '0' && medida.substr(1, 1) <= '9') {
      return medida
    } else {
      medida =
        (parseInt(medida.substr(0, 1).charCodeAt(0)) - 55) * 1000 + parseInt(medida.substr(2, 3))

      return medida
    }
  }

  const eliminarLinea = e => {
    e.preventDefault()

    if (!pedido_cargando) {
      const linea_seleccionada = e.target.dataset.linea

      confirmAlert({
        title: i18n.t('articulos_extrusion.titdelart'),
        message: i18n.t('articulos_extrusion.msgdelart'),
        closeOnEscape: true,
        closeOnClickOutside: true,
        buttons: [
          {
            label: i18n.t('articulos_extrusion.lblsi'),
            onClick: () =>
              dispatch(deleteLinea(linea_seleccionada, hash, pedido.id_pedido_seleccionado)),
          },
          {
            label: i18n.t('articulos_extrusion.lblno'),
          },
        ],
      })
    }
  }

  const modificarCantidad = e => {
    e.preventDefault()

    if (
      e.target.value !== 0 &&
      e.target.value !== '' &&
      parseInt(e.target.value) !== parseInt(props.linea.cantidad_pedida)
    ) {
      let linea = {
        articulo: e.target.dataset.articulo,
        descripcion: e.target.dataset.descripcion,
        precio_venta: 0,
        observaciones: '',
        estado_linea: 'B',
        cantidad_pedida: e.target.value,
        presentacion_pedido: e.target.dataset.presentacion_pedido,
        tipo_linea: 'P',
        sub_pres: '',
        sub_pres_cant: '',
        sub_pres_fc: '',
        presentacion_escogida: '',
        pres_fc: '',
      }

      dispatch(postLinea(linea, null, props.linea.id_pedido, 'S'))
    }
  }

  const validKeyForQuantity = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'Backspace']

  if (cargando_articulo) {
    return <Spinner showSpinner={true} />
  } else {
    return (
      <div className='container lineas-pedido tt-shopcart-table'>
        <div
          className='row linea-carrito'
          key={props.linea.id}>
          <div className='col-7 col-lg-4 col-xl-4'>
            {descripcion_sinonimo !== 'S' || !articulo
              ? props.linea.descripcion
              : articulo.articulo.codigo_sinonimo !== null
                ? articulo.articulo.codigo_sinonimo
                : props.linea.descripcion}
          </div>
          <div className='col-3 col-lg-2 col-xl-2'>
            {props.linea.sub_pres !== undefined &&
            props.linea.sub_pres !== null &&
            props.linea.sub_pres !== '' ? (
              props.linea.sub_pres_cant + ' X ' + props.linea.sub_pres
            ) : (
              <div className='tt-input-counter style-01'>
                <input
                  className='quantity-input'
                  type='text'
                  defaultValue={Number.parseFloat(props.linea.cantidad_pedida).toFixed(0)}
                  size='5'
                  data-articulo={props.linea.articulo}
                  data-presentacion_pedido={props.linea.presentacion_pedido}
                  data-descripcion={props.linea.descripcion}
                  readOnly={false}
                  onBlur={modificarCantidad}
                  onKeyDown={e => {
                    if (!validKeyForQuantity.includes(e.key)) {
                      e.preventDefault()
                    }
                  }}
                />
              </div>
            )}
          </div>
          <div
            className='col-5 col-lg-3 col-xl-3'
            style={{ display: 'flex', justifyContent: 'left' }}>
            {precio?.[props.linea.articulo] !== undefined &&
            precio?.[props.linea.articulo]?.[props.linea.presentacion_pedido] !== undefined &&
            precio?.[props.linea.articulo]?.[props.linea.presentacion_pedido].status !== 'error' &&
            precio?.[props.linea.articulo]?.[props.linea.presentacion_pedido].status !==
              'fetching' ? (
              <div style={{ display: 'inline-flex' }}>
                <div className='tt-quantity'>
                  {/* {Number.parseFloat(props.linea.cantidad_pedida).toFixed(0) +
                    ' (' +
                    precio[props.linea.articulo][props.linea.presentacion_pedido].presentacion +
                    ') X '} */}

                  {precio[props.linea.articulo][props.linea.presentacion_pedido]?.presentacion ??
                    ''}
                </div>
                <div className='tt-price'>
                  <Precio
                    codigo_articulo={props.linea.articulo}
                    mostrar_iva='N'
                    mostrar_pres='S'
                    presentacion={props.linea.presentacion_pedido}
                  />
                </div>
              </div>
            ) : (
              ''
            )}
          </div>
          <div
            className='col-5 col-lg-2 col-xl-2'
            style={{ display: 'flex', justifyContent: 'left' }}>
            {precio?.[props.linea.articulo] !== undefined &&
            precio?.[props.linea.articulo]?.[props.linea.presentacion_pedido] !== undefined &&
            precio?.[props.linea.articulo]?.[props.linea.presentacion_pedido].status !== 'error' &&
            precio?.[props.linea.articulo]?.[props.linea.presentacion_pedido].status !==
              'fetching' ? (
              <div style={{ display: 'inline-flex', gap: '10px' }}>
                <div>
                  {i18n.t('articulos_extrusion.lbltotal') + ': '}
                  {Intl.NumberFormat(locale, {
                    style: 'currency',
                    currency: moneda,
                  }).format(
                    Number.parseFloat(
                      (
                        precio?.[props.linea.articulo]?.[props.linea.presentacion_pedido]
                          ?.importe_bruto || 0
                      )
                        .toString()
                        .replace(/,/g, '.'),
                    ).toFixed(2),
                  )}
                </div>
                <div className='tt-quantity'>
                  {props?.linea?.datos_perfil?.[0] && props?.linea?.datos_perfil?.[0]?.tipo !== 'C'
                    ? Intl.NumberFormat().format(
                        Number.parseFloat(
                          props.linea.cantidad_pedida *
                            (convertirLongitud(props.linea.articulo) / 1000),
                        ).toFixed(2),
                      ) + ' MTS'
                    : ''}
                </div>
              </div>
            ) : (
              ''
            )}
          </div>

          <div className='col-2 col-lg-1 col-xl-1'>
            {props.linea.tipo_articulo !== 'F' ? (
              <a
                href='/#'
                className='tt-btn-close'
                data-linea={props.linea.id}
                onClick={eliminarLinea}>
                <span className='ocultar'>{i18n.t('articulos_extrusion.cerrar')}</span>
              </a>
            ) : (
              ''
            )}
          </div>
        </div>
      </div>
    )
  }
}

export default LineaCarritoExtrusion
